import { GridEnrichedColDef } from '@mui/x-data-grid-pro';
import { GridApiPro } from '@mui/x-data-grid-pro/models/gridApiPro';
import { action, computed, makeObservable, observable } from 'mobx';
import { MutableRefObject } from 'react';
import { RowViewModel } from './row';

export abstract class TableViewModel<
  TData extends object,
  TRowViewModel extends RowViewModel<TData, TableViewModel<TData, TRowViewModel>>
> {
  protected abstract _buildColDef(): GridEnrichedColDef[];

  buildColDef() {
    return this._buildColDef();
  }

  abstract createRow(entity: TData): TRowViewModel;

  get rows() {
    return this.data.map((e) => this.createRow(e));
  }

  data: TData[] = [];

  setData(data: TData[]) {
    this.data = data;
  }

  constructor(public apiRef?: MutableRefObject<GridApiPro>) {
    makeObservable(this, {
      rows: computed,
      setData: action,
      data: observable
    });
  }
}
